import React, { useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Button, Stack, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import ReactQuill from "react-quill";
import { useResponsive } from "../hooks/useResponsive";
import { assignCard } from "../services/apiCards";
import { removeHtmlTagsAndEntities } from "../utils";
import { useCards } from './../../src/reactQuery/cards.js'
import useToastPromise from "../hooks/useToast.js";
import { CustomButton } from "./Button/Button.js";
import useMutate from "../hooks/useMutate.js";
const modules = {
  toolbar: [
    [],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike"],
    ["link"],
    [{ list: "ordered" }, { list: "bullet" }],
    [], // Add color and background color options
    [],
    [],
  ],
};

const CommentForm = ({
  cardId,
  userId,
  onClose,
  boardId,
  parentTaskCardId,
  workflow_id,
}) => {
  const queryClient = useQueryClient();
  const isMobile = useResponsive("down", "md");
  const isSmallDevice = useResponsive("between", 200, 380);
  const validationSchema = Yup.object().shape({
    comment: Yup.string(),
  });
  
  const { refetch } = useCards(boardId);

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { comment: "" },
  });

  const { mutate, isPending } = useMutate(assignCard,["boards","mineCards"],
    ()=>{},
    () => {
      queryClient.invalidateQueries({
        queryKey: ["card", `${cardId}`],
      });
      queryClient.invalidateQueries({
        queryKey: [`comment`, String(cardId)],
      });

      queryClient.invalidateQueries({
        queryKey: [`subTasks`, parentTaskCardId],
        exact : true
      });

      queryClient.invalidateQueries({
        queryKey: [`cards`, `${boardId}`],
      });

      queryClient.invalidateQueries({
        queryKey: [`watching`, workflow_id],
      });

      refetch();
      onClose();
      //toast.success(res.data.message);
    },
    () => {
      //toast.error(error.response.data.message);
      onClose();
    },
  );

  // Handle form submission
  const onSubmit = useCallback((data) => {
    // Add your form submission logic here
    mutate({
      card_id: cardId,
      data: { assigned_to_user_id: userId, comment: data.comment },
    });
  }, [mutate, cardId, userId]);

  return (
    <form onSubmit={methods.handleSubmit(onSubmit)} className="comment-pop-up-form">
      <div style={{ marginTop: "5px", height: "208px" }}>
        <ReactQuill
          value={methods.getValues("comment")}
          onChange={(value) =>
            methods.setValue(
              "comment",
              removeHtmlTagsAndEntities(value).length === 0 ? "" : value
            )
          }
          modules={modules}
          style={{ height: "170px" }}
        />
      </div>
      <Typography className={"comments-react-quill"}>
        {methods.formState.errors.comment?.message}
      </Typography>
      <Stack
        sx={{
          justifyContent: "end",
          marginTop: isMobile ? (isSmallDevice ? "60px" : "35px") : "20px",
        }}
      >
        <CustomButton
          type="submit"
          disabled={isPending}
          className="comment-pop-up-send-btn"
          onClick={(e) => e.stopPropagation()}
        >
          Send
        </CustomButton>
      </Stack>
    </form>
  );
};

export default CommentForm;
